import {
  BEESWAX_MEDIA_PLATFORM_ID,
  FACEBOOK_MEDIA_PLATFORM_ID,
  GOOGLE_SEARCH_MEDIA_PLATFORM_ID
} from 'shared/src/domain/media-platform/media-platforms';
import type { MediaPlanCardSelection } from '../media-plans/media-plan-configuration-card';
import { beeswaxConfigBehavior } from './beeswax/beeswax-media-plan-config';
import { googleAdsConfigBehavior } from './google-ads/google-ads-media-plan-config';
import { metaConfigBehavior } from './meta/meta-media-plan-config';

// Per-platform configuration behaviour for the media-plan workspace card.
//
// The MediaPlanConfigurationCard UI itself is capabilities-driven and shared across DSPs, but the
// finalize step turns the user's selection into a prompt that names DSP-specific payload fields
// (Beeswax: campaign_mode, line_item.bidding.cpm_bid). That mapping is platform-specific, so each
// DSP implements it in its own folder (./beeswax/...) and registers it here — the same
// "register per platform" pattern as the preview-card registry. When a second DSP's *selection
// shape* diverges from Beeswax's (campaignMode/cpmBid), the next step is full per-platform
// configuration cards; until then the shared card + this behaviour hook is enough.
export type MediaPlanConfigBehavior = {
  buildProposePrompt: (selection: MediaPlanCardSelection) => string;
};

const REGISTRY: Record<number, MediaPlanConfigBehavior> = {
  [BEESWAX_MEDIA_PLATFORM_ID]: beeswaxConfigBehavior,
  [GOOGLE_SEARCH_MEDIA_PLATFORM_ID]: googleAdsConfigBehavior,
  [FACEBOOK_MEDIA_PLATFORM_ID]: metaConfigBehavior
};

export function getMediaPlanConfigBehavior(platformId: number): MediaPlanConfigBehavior {
  const behavior = REGISTRY[platformId];
  if (!behavior) {
    throw new Error(`No media plan config behavior registered for platform_id=${platformId}`);
  }
  return behavior;
}
